/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Theme } from "@mui/material";
import { CircleCheckIcon, CircleExclamationIcon, CircleInfoIcon, FontAwesomeIconProps, TriangleExclamationIcon } from "../../FontAwesome";
import { Level } from "../AppSnackbarContext/AppSnackbarItem";

export function getLevelColor(theme: Theme, level: Level | null) {
    switch (level) {
        case "Error":
            return theme.palette.error.main;
        case "Warning":
            return theme.palette.warning.main;
        case "Success":
            return theme.palette.success.main;
        default:
            return theme.palette.info.main;
    }
}

export function getLevelIcon(level: Level | null): React.FC<FontAwesomeIconProps> {
    switch (level) {
        case "Error":
            return CircleExclamationIcon;
        case "Warning":
            return TriangleExclamationIcon;
        case "Success":
            return CircleCheckIcon;
        default:
            return CircleInfoIcon;
    }
}